"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Versions = void 0;
const base_1 = require("../../../base");
const CapturedText_1 = require("./CapturedText");
const Chapters_1 = require("./Chapters");
const DocumentIntelligence_1 = require("./DocumentIntelligence");
const DocumentText_1 = require("./DocumentText");
const Faces_1 = require("./Faces");
const ImageIntelligence_1 = require("./ImageIntelligence");
const Metadata_1 = require("./Metadata");
const SmartTags_1 = require("./SmartTags");
const Thumbnail_1 = require("./Thumbnail");
const VideoIntelligence_1 = require("./VideoIntelligence");
exports.Versions = {
    CapturedText: CapturedText_1.CapturedText,
    Chapters: Chapters_1.Chapters,
    DocumentIntelligence: DocumentIntelligence_1.DocumentIntelligence,
    DocumentText: DocumentText_1.DocumentText,
    Faces: Faces_1.Faces,
    ImageIntelligence: ImageIntelligence_1.ImageIntelligence,
    Metadata: Metadata_1.Metadata,
    SmartTags: SmartTags_1.SmartTags,
    Thumbnail: Thumbnail_1.Thumbnail,
    VideoIntelligence: VideoIntelligence_1.VideoIntelligence,
    delete: (0, base_1.declare)({
        method: 'delete',
        path: '/workspaces/:workspaceId/assets/:assetId/versions/:clipId',
    }).as(),
};
//# sourceMappingURL=index.js.map